import {Injectable} from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})

export class GoogleAnalyticsService {
  public sendKeyEvent(eventName: string, eventData: any) {
    const keyEventData = {
      ...eventData,
      isKeyEvent: true,
      timestamp: new Date().toISOString()
    };

    gtag('event', eventName, keyEventData);
  }
}
